/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ThreadsControllerFindAllQueryResponse, ThreadsControllerFindAllQueryParams, ThreadsControllerFindAll401, ThreadsControllerFindAll403 } from "../../models/threadsController/ThreadsControllerFindAll";

function getThreadsControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/threads` as const }  
  return res
}

/**
 * @description Get paginated list of threads for the current user, with optional filtering and sorting.
 * @summary List threads
 * {@link /api/v1/threads}
 */
export async function threadsControllerFindAll(params?: ThreadsControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ThreadsControllerFindAllQueryResponse, ResponseErrorConfig<ThreadsControllerFindAll401 | ThreadsControllerFindAll403>, unknown>({ method : "GET", url : getThreadsControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}